export default {
  id: null,
  emailHost: null,
  emailPort: null,
  emailFrom: null,
  replyTo: null,
  safeConnection: null,
  envioAutenticado: null,
  emailUser: null,
  emailPassword: null,
  aliases: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/emailenviomodel.js